import { EKGImportConstants } from './ekgImport.constants'
import { IEKGImportAction, IEKGImportState } from './ekgImport.types'

export const EKG_IMPORT_MODULE_ID = 38
export const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif']

export const initialEKGImportState: IEKGImportState = {
  isLoading: false,
  loadedEvents: false,
  visitedReports: false,
  monitorOptions: [],
  fromTimeOptions: [],
  powerOnTimeList: [],
  selectedPowerOnTime: null,
  eventsList: [],
  selectedEvents: [],
  reportsList: [],
  selectedReports: [],
  filteredMonitor: null,
  filteredFrom: null,
  loadingReportId: null,
  reportAttachments: [],
  reportAttachmentToDelete: null,
  procedureEvents: [],
  currentProcedure: null,
}

export function ekgImportReducer(
  state: IEKGImportState = initialEKGImportState,
  action: IEKGImportAction
): IEKGImportState {
  switch (action.type) {
    case EKGImportConstants.SET_MONITOR_OPTIONS:
      return { ...state, monitorOptions: action.monitorOptions }
    case EKGImportConstants.GET_POWER_ON_TIME_LIST_RESULTS:
      return { ...state, isLoading: true }
    case EKGImportConstants.SET_POWER_ON_TIME_LIST_RESULTS:
      return { ...state, isLoading: false, powerOnTimeList: action.powerOnTimeList }
    case EKGImportConstants.SET_SELECTED_POWER_ON_TIME:
      return { ...state, loadedEvents: false, visitedReports: false, selectedPowerOnTime: action.selectedPowerOnTime }
    case EKGImportConstants.GET_EVENTS_AND_REPORTS_RESULTS:
      return { ...state, isLoading: true }
    case EKGImportConstants.SET_EVENTS_LIST_RESULTS:
      return { ...state, isLoading: false, loadedEvents: true, eventsList: action.eventsList }
    case EKGImportConstants.SET_SELECTED_EVENTS:
      return { ...state, selectedEvents: action.selectedEvents }
    case EKGImportConstants.SET_REPORTS_LIST_RESULTS:
      return { ...state, isLoading: false, reportsList: action.reportsList }
    case EKGImportConstants.SET_VISITED_REPORTS:
      return { ...state, visitedReports: action.visitedReports }
    case EKGImportConstants.SET_SELECTED_REPORTS:
      return { ...state, selectedReports: action.selectedReports }
    case EKGImportConstants.SET_FILTERED_FROM:
      return { ...state, isLoading: false, filteredFrom: action.filteredFrom }
    case EKGImportConstants.SET_FROM_TIME_OPTIONS:
      return { ...state, isLoading: false, fromTimeOptions: action.fromTimeOptions }
    case EKGImportConstants.GET_FILTERED_FROM:
      return { ...state, isLoading: true }
    case EKGImportConstants.SET_FILTERED_MONITOR:
      return { ...state, isLoading: false, filteredMonitor: action.filteredMonitor }
    case EKGImportConstants.GET_FILTERED_MONITOR:
      return { ...state, isLoading: true }
    case EKGImportConstants.GET_REPORT_IMAGE:
      return { ...state, loadingReportId: action.reportId }
    case EKGImportConstants.GET_REPORT_ATTACHMENT_IMAGE:
      return { ...state, loadingReportId: action.reportId }
    case EKGImportConstants.UPDATE_REPORTS_LIST:
      return { ...state, reportsList: action.reportsList }
    case EKGImportConstants.SAVE_EKG_IMPORT_DATA:
      return { ...state }
    case EKGImportConstants.SET_PROCEDURE_EVENTS:
      return { ...state, procedureEvents: action.procedureEvents }
    case EKGImportConstants.SET_CURRENT_PROCEDURE:
      return { ...state, currentProcedure: action.currentProcedure }
    case EKGImportConstants.SAVE_REPORT_ATTACHMENTS:
      return { ...state, reportAttachments: action.reportAttachments }
    case EKGImportConstants.DELETE_REPORT_ATTACHMENT:
      return { ...state, reportAttachmentToDelete: action.reportAttachmentToDelete }
    case EKGImportConstants.RESET_EKG_AFTER_FLOW_COMPLETES:
      return {
        ...initialEKGImportState,
        monitorOptions: state.monitorOptions,
        fromTimeOptions: state.fromTimeOptions,
        reportAttachments: state.reportAttachments,
      }
    case EKGImportConstants.RESET_EKG_AFTER_LEAVING_CHART:
      return {
        ...initialEKGImportState,
        monitorOptions: state.monitorOptions,
        fromTimeOptions: state.fromTimeOptions,
      }
    case EKGImportConstants.RESET_EKG_AFTER_LEAVING_SERVICE:
      return {
        ...initialEKGImportState,
      }
    default:
      return state
  }
}
